export default __webpack_public_path__ + "static/media/vambraces_of_the_vanguard.f2a63082.jpg";